import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import { FC } from "react";

/**
 * Props for `CheckoutForm`.
 */
export type CheckoutFormProps = SliceComponentProps<Content.CheckoutFormSlice>;

/**
 * Component for "CheckoutForm" Slices.
 */
const CheckoutForm: FC<CheckoutFormProps> = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      Placeholder component for CheckoutForm (variation: {slice.variation})
      slices.
      <br />
      <strong>You can edit this slice directly in your code editor.</strong>
      {/**
       * 💡 Use your own AI agent with the Prismic CLI
       * 📚 Docs: https://prismic.io/docs/ai#create-slices
       */}
    </section>
  );
};

export default CheckoutForm;
